import { render } from "./distributorwisedealerstock.vue?vue&type=template&id=c185f964"
import script from "./distributorwisedealerstock.vue?vue&type=script&lang=js"
export * from "./distributorwisedealerstock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__